<template>
  <div class="global-chat-active-attendees-list__attendee-item" :id="`global-chat-list-attendee-${attendeeFields.event_attendee_id}`" ref='membercard' tabindex="0">

    <span v-waypoint="{ active: true, callback: wayPointPassed }" v-if="waypoint"></span>

    <global-chat-avatar-bubble 
      v-bind:first-name="attendeeFields.first_name" 
      v-bind:last-name="attendeeFields.last_name"
      v-bind:avatar="attendeeFields.user_avatar_url_medium"
      v-bind:can-moderate="isModerator"
      v-bind:show-status="false"
    >
    </global-chat-avatar-bubble>

    <div class="global-chat-active-attendees-list__attendee-name ml-2 pt-2">
      <div class="attendeeInfo">
        <span class="attendeeName">{{ `${attendeeFields.first_name} ${attendeeFields.last_name}` }}</span>
        <span class="attendeeSubheaders" v-if="room.attendee_subheaders" v-html="attendeeSubheaders"></span>
      </div>
      <div v-if="hasSocial" class="attendeeSocial">
        <div class="attendeeSocialBox" v-bind:class="member.socialActive ? 'active':''">
          <ul class="global-chat-active-attendees-list__social">
              <li v-if="isValidURL(attendeeFields.facebook_url)">
                  <a v-bind:href="attendeeFields.facebook_url" target="_blank"><i class="far fa-facebook-f"></i></a>
              </li>
              <li v-if="isValidURL(attendeeFields.twitter_url)">
                  <a v-bind:href="attendeeFields.twitter_url" target="_blank"><i class="far fa-twitter"></i></a>
              </li>
              <li v-if="isValidURL(attendeeFields.instagram_url)">
                  <a v-bind:href="attendeeFields.instagram_url" target="_blank"><i class="far fa-instagram"></i></a>
              </li>
              <li v-if="isValidURL(attendeeFields.linkedin_url)">
                  <a v-bind:href="attendeeFields.linkedin_url" target="_blank"><i class="far fa-linkedin"></i></a>         
              </li>
          </ul>
        </div>
        <div class="attendeeSocialButton" v-on:click="toggleSocialActive(member)">
          <i class="fas fa-ellipsis-v"></i>
        </div>
      </div>
      <span v-if="isBlocked" class='blocked-text-span'>{{lang.get('event_strings.global-chat.blocked_label')}}</span>
          
    </div>

    <div class="global-chat-active-attendees-list-actions" v-if="!isMe">
      <i v-on:click="toggleMenuExpanded()" class="fas fa-ellipsis-v action-expand-btn"></i>
      <div class='message-action-card' v-if="menuExpanded">
        <div v-on:click="handleDirectMessage(member)" class='global-chat-active-attendees-list-action' >
          <i class="fas fa-comment-dots"></i>
          Message
        </div>
        <div class='global-chat-active-attendees-list-action'
          v-bind:class = "isMemberFlagged ? 'global-chat-active-attendees-list__flag-button-flagged':'global-chat-active-attendees-list__flag-button-unflagged'"
          v-if="canModerate"
          v-on:click="handleFlagUnflagAttendee(member)">
          <i class="far fa-flag" v-if="!isMemberFlagged"></i>
          <i class="fas fa-flag" v-if="isMemberFlagged"></i>
          Flag
        </div>
        <div v-on:click="handleBlockToggle(member)" class='global-chat-active-attendees-list-action' >
          <i class="far fa-minus-circle" v-if="!isBlocked"></i>
          <i class="fas fa-minus-circle" v-if="isBlocked"></i>
          Block
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './GlobalChatAvatarBubble'

export default {

  props: ['member', 'canModerate', 'isFlagged', 'isBlocked', 'isMe', 'waypoint', 'room'],

  data: function() {
    return {
      menuExpanded: false,
      socialActive: false
    };
  },

  computed: {
    attendeeFields: function () {
      return this.member.attendee_fields
    },

    attendeeSubheaders: function () {
      return this.formatSubheaders()
    },

    isMemberFlagged: function () {
      return this.room.flagged_attendees.includes(this.member.id)
    },

    isModerator: function () {
      return this.member.groups && this.member.groups.length
    },

    hasSocial: function () {
      var flag = false
      if(this.member.attendee_fields.facebook_url){
        if(this.isValidURL(this.member.attendee_fields.facebook_url)) flag = true;
      }else if(this.member.attendee_fields.twitter_url){
        if(this.isValidURL(this.member.attendee_fields.twitter_url)) flag = true;
      } else if(this.member.attendee_fields.instagram_url){
        if(this.isValidURL(this.member.attendee_fields.instagram_url)) flag = true;
      } else if(this.member.attendee_fields.linkedin_url){
        if(this.isValidURL(this.member.attendee_fields.linkedin_url)) flag = true;
      }
      return flag;
    }
  },

  watch: {
    isSelected: function () {
      if (!this.isSelected) this.menuExpanded = false
    }
  },

  methods: {
    toggleMenuExpanded: function () {
      this.menuExpanded = !this.menuExpanded
    },

    handleFlagUnflagAttendee: function () {
      this.$root.$emit('flag-unflag-attendee', this.member)
    },

    handleBlockToggle: function () {
      this.$root.$emit('handle-block-toggle', this.member)
    },

    wayPointPassed: function (e) {
      if (e.direction == 'top') {
        this.$root.$emit('get-more-members', this.room.id)
      }
    },
    handleDirectMessage: function () {
      this.$root.$emit('handle-direct-message', this.member)
    },
    isValidURL: function (url) {
      var regex = "((http|https)://)(www.)?" + "[a-zA-Z0-9@:%._\\+~#?&//=]" + "{2,256}\\.[a-z]" + "{2,6}\\b([-a-zA-Z0-9@:%" + "._\\+~#?&//=]*)"
      if (!url) return false

      return url.match(regex)
    },

    toggleSocialActive: function(member) {
      this.member.socialActive = !this.member.socialActive;
      console.log('>>',this.member.socialActive)
    },

    isEmptyValue: function(value) {
        var hasValue = value.replace(/<\/?[^>]+(>|$)/g, "")
        return !hasValue || value === ''
    },

    formatSubheaders: function() {
      var eaf = this.attendeeFields
      var shortcodePattern = /\[\[(.+?)\]\]/g

      // Replace shortcode with attendee value
      var subheaders = this.room.attendee_subheaders.replace(shortcodePattern,
        function (param, field) {
          return eaf[field] || ''
      });

      // Strip out floating commas if attendee field value is empty & reformat
      var subArr = subheaders.split(',')
      if (subArr.length > 1) {
        var newVal = ''
        $.each(subArr, (k) => {
            var currVal = subArr[k].trim()
            var nextVal = subArr[k+1] ? subArr[k+1].trim() : ''
            var isLastVal = (k === subArr.length-1)

            if ((!this.isEmptyValue(currVal) && !this.isEmptyValue(nextVal)) && !isLastVal) {
              currVal+=', '
            }
            newVal+=currVal
        })
        subheaders = newVal
      }
      return subheaders
    }
  },

  mounted: function () {
    if (this.lastMember) {
      this.setMemberWayPoint()
      this.member.socialActive = false
    }
  }

};
</script>

<style scoped>
  .action-expand-btn {
    position: relative;
    align-self: center
  }

  .message-action-card {
    position: absolute;
    right: 1em;
    top: 0;
    background: white;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    z-index: 999;
  }

  .message-action-card i {
    padding-right: 0.5rem;
  }

</style>